module.exports = __webpack_public_path__ + "dfb457e13711f0996286e5a9bc8e1ed5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/planet-earth.png
// module id = 2410
// module chunks = 0